import PropTypes from 'prop-types'
import React from 'react'
import Input from 'components/Input'
import ContentText from 'components/ContentText'
import { COMMENT_MODEL_KEY, COMMENT_MODEL_PLACEHOLDER } from 'models/daos/comment/constants'
import TextBody from 'components/TextBody'

class CommentText extends React.Component {
  renderCommentValue () {
    return <ContentText value={this.props.value} />
  }

  renderField () {
    const props = {
      placeholder: COMMENT_MODEL_PLACEHOLDER[COMMENT_MODEL_KEY.VALUE],
      value: this.props.value,
      onChange: (event) => this.props.onChange(event.target.value)
    }
    return <Input {...props} />
  }

  renderPlaceholder () {
    const placeholder = COMMENT_MODEL_PLACEHOLDER[COMMENT_MODEL_KEY.VALUE]
    return (
      <div onClick={this.props.onClick}>
        <TextBody>{placeholder}</TextBody>
      </div>
    )
  }

  render () {
    if (this.props.onChange) {
      return this.renderField()
    }
    if (this.props.value != null) {
      return this.renderCommentValue()
    }
    return this.renderPlaceholder()
  }
}

CommentText.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func
}
export default CommentText
